import { BaseField } from './BaseField';

const imgGroup40428 = "/assets/03d7013dae5803e41b5fa764e4e054bf6aecb1cf.svg";

export class BedroomsField extends BaseField {
  constructor() {
    super({
      key: 'bedrooms',
      icon: imgGroup40428,
      defaultLabel: 'Sypialnie'
    });
  }

  getLabel(property) {
    return this.defaultLabel;
  }

  renderForList(property) {
    const rooms = property.specifications.rooms;

    if (rooms.label) {
      return { label: this.getLabel(property), value: rooms.label };
    }

    return {
      label: this.getLabel(property),
      value: rooms.totalExtraVariant
        ? `${rooms.total} lub ${rooms.totalExtraVariant}`
        : rooms.total
    };
  }

  renderForCard(property) {
    return this.renderForList(property);
  }
}
